// removed by extract-text-webpack-plugin
module.exports = {"theme":"#409eff"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/element-variables.scss
// module id = +hAf
// module chunks = 24